import { render } from "./FaqsComponent.vue?vue&type=template&id=4d4c2f4d"
import script from "./FaqsComponent.vue?vue&type=script&lang=js"
export * from "./FaqsComponent.vue?vue&type=script&lang=js"

import "./FaqsComponent.vue?vue&type=style&index=0&id=4d4c2f4d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__